const useStripePayment = import.meta.env.VITE_USE_STRIPE_PAYMENT

const checkoutChildRoute =
    useStripePayment == 'true'
        ? {
              path: '',
              name: 'CheckoutPage',
              component: () =>
                  import(/* webpackChunkName: "checkout" */ '@/routes/crane/checkout_page.vue'),
              meta: {
                  breadcrumb: {
                      label: 'checkout',
                  },
              },
          }
        : {
              path: '',
              name: 'CheckoutPage',
              component: () =>
                  import(
                      /* webpackChunkName: "checkout" */ '@/routes/crane/checkout_page_authorize.vue'
                  ),
              meta: {
                  breadcrumb: {
                      label: 'checkout',
                  },
              },
          }

export default [
    {
        path: '/checkout',
        component: () =>
            import(/* webpackChunkName: "checkout" */ '@/components/checkout/CheckoutLayout.vue'),
        children: [checkoutChildRoute],
    },
]
